import { render, staticRenderFns } from "./WholeTreatment.vue?vue&type=template&id=532bec38&"
import script from "./WholeTreatment.vue?vue&type=script&lang=ts&"
export * from "./WholeTreatment.vue?vue&type=script&lang=ts&"
import style0 from "./WholeTreatment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports